import { useAtomValue } from 'jotai'
import { invoiceIsEditableAtom } from '../atoms/invoiceEditing.atom'
import { usePermissions } from 'lib/rbac'

export const useIsInvoiceEditable = () => {
  const isEditable = useAtomValue(invoiceIsEditableAtom)
  const { can } = usePermissions()

  return can('org.invoice:update') && isEditable
}
